module.exports = __webpack_public_path__ + "static/media/coupon.3271b2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/coupon.png
// module id = 545
// module chunks = 6